import { CircularProgress, Stack } from "@mui/material";

const Spinner = () => {
  return (
    <Stack
      sx={{
        height: "352px",
        alignItems: "center",
        width: "100%",
        justifyContent: "center",
      }}
    >
      <CircularProgress sx={{ color: "#424242" }} />
    </Stack>
  );
};
export default Spinner;
